import { Component , OnInit, signal, WritableSignal, inject, input, effect} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IItem } from '../../../../../models/IItem';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiService } from '../../../../../services/api.service';
import { SlicePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { DefaultImageComponent } from "../../../default-image/default-image.component";

@Component({
  selector: 'app-auction-homepage-top-items',
  imports: [SlicePipe, RouterModule, DefaultImageComponent, CommonModule],
  templateUrl: './auction-homepage-top-items.component.html',
  styleUrl: './auction-homepage-top-items.component.scss'
})

export class AuctionHomepageTopItemsComponent implements OnInit{
  private readonly apiService = inject(ApiService)
  private readonly sanitizer = inject(DomSanitizer);

  public auctionId = input(0);

  topItems: WritableSignal<IItem[] | null> = signal(null);
  topItemList: IItem[] = [];

  constructor(){
    effect(() => {
      const withValue = this.topItems();
      if (withValue) {
        this.topItemList = withValue.map(item => ({
          ...item,
          imageUrl: item.imageUrl?.trim().toLowerCase() !== 'null' && item.imageUrl?.trim()
            ? `${item.imageUrl.trim()}`
            : '/item-default.jpg',
          id: item.id,
          isFavorite: item.isFavorite,
          numberOfBids: item.numberOfBids
        }));
      }
    });
  }

  ngOnInit(): void {    
    this.apiService.getTopItems( this.auctionId()).subscribe((data) => {
      this.topItems.set(data);
    });
  }

  protected getSafeUri(uri: string | undefined | null): SafeResourceUrl {
    if (uri != undefined && uri != null) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(uri)
    }
    return "";
  }

}
